import { Indicator, Root } from "@radix-ui/react-progress";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type Props = ComponentProps<typeof Root>;

export const Progress: FC<Props> = ({ className, value, ...props }) => (
  <Root
    data-slot="progress"
    className={cn(
      "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
      className,
    )}
    {...props}
  >
    <Indicator
      data-slot="progress-indicator"
      className="bg-primary h-full w-full flex-1 transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </Root>
);
